import { type DateRange, getRange } from "@pentacode/core";
import type { DateString } from "@pentacode/openapi";
import { type TemplateResult, html } from "lit";
import { createRoute, lazyElement } from "../../../lib/tsr/router";
import { redirectTo } from "../../app-router-context";
import { employeesAllRoute } from "../../app-routes";
import type { EmployeesAllLayoutRoute } from "./employees-all.route";
import { timeReportsQuery } from "./time-reports.query";

export function createTimeRoute(parent: EmployeesAllLayoutRoute) {
    return createRoute({
        getParentRoute: () => parent,
        path: "time",
        staticData: {
            title: "Arbeitszeiten: Alle Mitarbeiter",
            helpPage: "/handbuch/mitarbeiter/arbeitszeiten",
            menu: employeesAllRoute("time"),
        },
        validateSearch: (search: Record<string, unknown>): Partial<DateRange> => ({
            from: search.from as DateString | undefined,
            to: search.to as DateString | undefined,
        }),
        beforeLoad: ({ search }): void => {
            if (!search.from || !search.to) {
                redirectTo("/employees/all/time", { ...search, ...getRange(new Date(), "month") });
            }
        },
        loaderDeps: ({ search }) => ({ from: search.from!, to: search.to! }),
        // fetchQuery, not ensureQueryData: a mutation's invalidateQueries only
        // marks the query stale, and the next load must refetch it.
        loader: ({ deps, context }) =>
            context.queryClient.fetchQuery({
                ...timeReportsQuery(context.app, deps, context.app.employeeFilters.filters),
                staleTime: 30_000,
            }),
        component: ({ match }): TemplateResult =>
            html`<ptc-employees-time-all
                class="fullbleed"
                .reports=${match.loaderData ?? []}
                .range=${{ from: match.search.from, to: match.search.to }}
            ></ptc-employees-time-all>`,
    }).lazy(lazyElement(() => import("./employees-time-all")));
}
